import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8a0e8493bd14b55bb34bc4bd1c6dd6ed.jpg"
          alt="LineFlow Underground & Civil"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-32 text-center w-full">
        <div className="inline-block px-5 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
          <span className="text-white font-bold text-sm tracking-wide">Professional Plumbing & Civil Engineering</span>
        </div>

        <h1 className="text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-6 leading-tight drop-shadow-2xl">
          LineFlow Underground<br />& Civil
        </h1>

        <p className="text-xl lg:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
          Specializing in new home plumbing installation and underground civil engineering projects. Professional quality, reliable service.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white text-lg font-bold rounded-xl hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('services');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-bold rounded-xl hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border-2 border-white/30"
          >
            Our Services
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-black text-[#FF6B35] mb-2">500+</div>
            <div className="text-white font-semibold">Completed Projects</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-black text-[#FF6B35] mb-2">10+</div>
            <div className="text-white font-semibold">Years Experience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-black text-[#FF6B35] mb-2">100%</div>
            <div className="text-white font-semibold">Licensed & Insured</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
